import * as React from "react"
import GlossaryModal from "./glossary-modal"
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from "react-redux"
import * as ActionCreators from "../../action-creators"
import { CardModalNotOkButton } from "../modal"
import { Word, LocalAuthority } from "../../model"
import { Names } from "../local-authority/local-authority-detail/add-word-modal"
import { updateWord, deleteWord } from "../../service/sfp/word-service"
import { ReducerState } from "../../reducer";

class ViewGlossaryModal
    extends React.Component<ViewGlossaryModalProps & PropsFromDispatch, ViewGlossaryModalState> {
    constructor(props: ViewGlossaryModalProps & PropsFromDispatch) {
        super(props)
        this.state = {
            definitionLength: 0,
            index: null,
            isEditing: [],
            isSubmitting: []
        }
    }

    render() {
        return (
            <GlossaryModal definitionLength={this.state.definitionLength}
                glossary={this.props.localAuthority.glossary}
                isEditing={this.state.isEditing}
                isSubmitting={this.state.isSubmitting}
                onChangeDefinition={(e) => { this.handleOnChangeDefinition(e) }}
                onClickCloseButton={e => { this.props.onClickCloseButton(e) }}
                onClickDeleteWord={(i, id, term, e) => { this.handleDeleteWord(i, id, term, e) }}
                onClickEditingWord={(i, e) => { this.handleEditingWord(i, e) }}
                onClickFooterButton={(b, e) => { this.props.onClickFooterButton(b, e) }}
                onSubmit={e => { this.handleUpdateWord(e) }} />
        )
    }

    private handleDeleteWord(index: number, wordId: number, term: string, event: React.SyntheticEvent<Element>) {
        event.preventDefault()
        const localAuthority = this.props.localAuthority
        const message = `Êtes-vous certains de vouloir supprimer le mot ${term} ?`

        if (confirm(message)) {
            const isSubmitting = this.state.isSubmitting

            isSubmitting[index] = true
            this.setState({ isSubmitting }, () => {
                deleteWord(wordId, localAuthority)
                    .then(() => this.resolveDeleteWord(wordId, index, event))
                    .catch(reason => this.rejectRequest(reason))
            })
        }
    }

    private handleEditingWord(index: number, event: React.SyntheticEvent<Element>): void {
        event.preventDefault()
        const isEditing = this.state.isEditing
        isEditing[index] = true
        this.setState({ isEditing, index })
    }

    private handleOnChangeDefinition(event: React.SyntheticEvent<Element>): void {
        event.preventDefault()
        const target = event.target as HTMLTextAreaElement
        const definition = target.value

        definition ? this.setState({ definitionLength: definition.length }) : ''
    }

    private handleUpdateWord(event: React.SyntheticEvent<Element>): void {
        event.preventDefault()
        const localAuthority = this.props.localAuthority
        const glossary = localAuthority.glossary
        const index = this.state.index
        const isEditing = this.state.isEditing
        const isSubmitting = this.state.isSubmitting
        const form = event.target as HTMLFormElement
        const formData = new FormData(form)

        if (!formData.get(Names.DEFINITION) && !formData.get(Names.TERM)) { this.props.onClickCloseButton(event); return; }

        const definition = formData.get(Names.DEFINITION).toString()
        const id = parseInt(formData.get(Names.ID).toString())
        const term = formData.get(Names.TERM).toString()
        const newWord = { id, term, definition } as Word
        const oldWord = glossary.find(word => word && word.id === id)
        if (newWord.definition === oldWord.definition && newWord.term === oldWord.term) { isEditing[index] = false; this.setState({ isEditing }); return }

        isSubmitting[index] = true
        this.setState({ isSubmitting }, () => {
            updateWord(newWord, localAuthority)
                .then(word =>
                    this.resolveUpdateWord(word, this.props.localAuthority, index, event))
                .catch(reason =>
                    this.rejectRequest(reason))
        })
        event.stopPropagation()
    }

    private resolveDeleteWord(wordId: number, index: number, event: React.SyntheticEvent<Element>): void {
        const localAuthority = this.props.localAuthority
        const glossary = localAuthority.glossary
        const isSubmitting = this.state.isSubmitting
        const wordIndex = glossary.findIndex(word => word.id === wordId)
        glossary.splice(wordIndex, 1)

        this.props.actions.updateCurrentLocalAuthority(localAuthority)
        isSubmitting[index] = false
        this.setState({ isSubmitting }, () => {
            this.props.onClickCloseButton(event)
        })
        event.stopPropagation()
    }

    private resolveUpdateWord(word: Word, localAuthority: LocalAuthority, index: number, event: React.SyntheticEvent<Element>) {
        const isEditing = this.state.isEditing
        const isSubmitting = this.state.isSubmitting

        localAuthority.glossary.splice(index, 1, word)
        this.props.actions.updateCurrentLocalAuthority(localAuthority)
        isEditing[index] = false
        isSubmitting[index] = false
        this.setState({ isEditing, isSubmitting }, () => {
            this.props.onClickCloseButton(event)
        })
    }

    private rejectRequest(reason) { }
}

const mapStateToProps = (state: ReducerState) => state
const mapDispatchToProps = (dispatch: Dispatch<any>) => (
    { actions: bindActionCreators(ActionCreators, dispatch) }
)

export default connect(mapStateToProps, mapDispatchToProps)(ViewGlossaryModal)

export interface ViewGlossaryModalProps {
    localAuthority: LocalAuthority
    onClickCloseButton(event: React.SyntheticEvent<Element>): void
    onClickFooterButton(button: CardModalNotOkButton, event: React.SyntheticEvent<Element>): void
}

interface ViewGlossaryModalState {
    definitionLength: number
    index: number
    isEditing: boolean[]
    isSubmitting: boolean[]
}

interface PropsFromDispatch {
    actions: typeof ActionCreators
}

export namespace GlossaryActions {
    export const UPDATE = "update"
    export const DELETE = "delete"
}



// WEBPACK FOOTER //
// ./src/component/glossary-modal/index.tsx